// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2Omdb","info":"UpdateTermsInfo_info__Mwqy1"};